"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bboxesRelativeReducer = void 0;
var utils_1 = require("../../../utils");
var bboxes_relative_1 = require("../../types/record/bboxes-relative");
var bboxesRelativeReducer = function (state, change) {
    return state.withMutations(function (st) {
        var currentIdx = st.historyIdx;
        var current = st.history.get(currentIdx, bboxes_relative_1.defaultValue);
        if (change.op === 'input' && (0, utils_1.Iis)(current.toList(), change.value)) {
            // 入力値が現在の値と同じときはchangeを無視する
            return;
        }
        st.set('lastOp', change.op);
        st.update('historyIdx', function (currentIdx) {
            switch (change.op) {
                case 'add':
                case 'remove':
                case 'remove-all':
                case 'resize':
                    return currentIdx + 1;
                case 'undo':
                    return Math.max(0, currentIdx - 1);
                case 'redo':
                    return Math.min(st.history.size - 1, currentIdx + 1);
                case 'input': // TODO inputでundo-historyをリセットするかどうかは選べるようにする（？）
                case 'reset-undo-history':
                    return 0;
            }
        });
        st.update('history', function (history) {
            switch (change.op) {
                case 'input': {
                    var next = (0, utils_1.IMap)(change.value.map(function (x) { return [x.id, x]; }));
                    return history.clear().push(next);
                }
                case 'add': {
                    var next = current.set(change.value.id, change.value);
                    return history.take(currentIdx + 1).push(next);
                }
                case 'remove': {
                    var next = current.remove(change.value);
                    return history.take(currentIdx + 1).push(next);
                }
                case 'remove-all': {
                    var next = (0, utils_1.IMap)();
                    return history.take(currentIdx + 1).push(next);
                }
                case 'resize': {
                    var next = current.set(change.value.id, change.value);
                    return history.take(currentIdx + 1).push(next);
                }
                case 'undo':
                case 'redo':
                    return history;
                case 'reset-undo-history':
                    return history.slice(currentIdx, currentIdx + 1);
            }
        });
    });
};
exports.bboxesRelativeReducer = bboxesRelativeReducer;
